
import Vue, { PropType, VNode } from 'vue';
import { declension } from '@/utils/declension';

export default Vue.extend({
    functional: true,

    props: {
        amount: {
            type: Number,
        },
        words: {
            type: (Array as unknown) as PropType<[string, string, string]>,
        },
    },

    render(h, context): VNode {
        const { amount, words } = context.props;

        if (typeof amount !== 'number' || isNaN(amount)) {
            return h();
        } else if (!Array.isArray(words)) {
            console.warn(`Array expected. Parameter 'words' has typeof ${typeof words})`);
            return h('span', {}, [amount.toString()]);
        }

        const word = declension(amount, words);
        const { prepend, append } = context.slots();

        return h('span', {}, [prepend, ' ', amount, ' ', word, ' ', append]);
    },
});
